import clsx from 'clsx'
import SharedScenarioItem, { IScenarioInfo } from 'components/SharedScenarioItem/SharedScenarioItem'
import { useTranslation } from 'react-i18next'

import style from './ScenarioTable.module.css'

const ScenarioTable = ({
  scenarios,
  highlightedScenarioId,
  onScenarioClick,
  onLaunchScenario,
  onScenariosUpdated,
  className,
  hideIdColumn = false,
  hideRobotColumn = false,
  hideDelete,
  showExclude,
  robotColumnTitle = 'Robot type',
}: {
  scenarios: IScenarioInfo[]
  highlightedScenarioId?: number
  onScenarioClick?: (id: number, missionIds: Array<number | string>) => void
  onLaunchScenario?: (scenario: IScenarioInfo) => void
  onScenariosUpdated: () => void
  className?: string
  hideIdColumn?: boolean
  hideRobotColumn?: boolean
  hideDelete?: boolean
  showExclude?: boolean
  robotColumnTitle?: string
}) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(style.root, className)}>
      <div
        className={clsx(style.tableHeader, {
          [style.tableHeaderNoId]: hideIdColumn && !hideRobotColumn,
          [style.tableHeaderNoRobot]: !hideIdColumn && hideRobotColumn,
          [style.tableHeaderNoIdNoRobot]: hideIdColumn && hideRobotColumn,
        })}
      >
        <span></span>
        {!hideIdColumn && <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.id')}</div>}
        <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.name')}</div>
        <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Missions</div>
        {!hideRobotColumn && <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>{robotColumnTitle}</div>}
        <div className={style.tableHeaderItemSmall} />
      </div>
      {scenarios.length > 0 ? (
        <div className={style.table}>
          {scenarios.map(scenario => (
            <SharedScenarioItem
              key={scenario.id}
              scenario={scenario}
              highlighted={highlightedScenarioId === scenario.id}
              onClick={() => onScenarioClick?.(scenario.id, scenario.missions_ids ?? [])}
              onLaunch={onLaunchScenario}
              onScenariosUpdated={onScenariosUpdated}
              hideIdColumn={hideIdColumn}
              hideRobotColumn={hideRobotColumn}
              hideDelete={hideDelete}
              showExclude={showExclude}
            />
          ))}
        </div>
      ) : (
        <div className={style.emptyWrapper}>
          <div className={style.emptyTitle}>No scenarios found</div>
        </div>
      )}
    </div>
  )
}

export default ScenarioTable
